
import {useConfig,useDealerInfo,useLogger, useAssociatedDealers, useDealerSwitch, useDealerMask} from '@gplibraries/react/hooks';
import {ErrorBoundary,PageTitle,Breadcrumbs, Icon} from '@gplibraries/react/components';

import {useNavigate } from 'react-router';
import { useEffect} from "react";

const WrongDivisionContent = () => {
  const env = useConfig('environment');
  const isProd = env === 'production';

  const otherDivisionUrl = isProd
    ? 'https://dealers.greatplainsmfg.com'
    : 'https://dev-dealers.greatplainsmfg.net';

  const { data: dealerInfo, loading: dealerInfoLoading } = useDealerInfo();
  const { data: mask, loading: maskLoading } = useDealerMask();
  const navigate = useNavigate();
  const switchDealer = useDealerSwitch();
  const { data: associatedDealers } = useAssociatedDealers();

  const loading = dealerInfoLoading || maskLoading;

  const divisions = Array.isArray(dealerInfo?.divisions)
    ? dealerInfo.divisions
    : [];

  const hasDivision02 = divisions.some((d) =>
    String(d)?.includes('02')
  );

  useEffect(() => {
    // If the current mask/dealer is an LP dealer OR the user is not currently
    // masked, they should not be on this page.
    if (!loading && (hasDivision02 || mask === false)) {
      navigate('/');
    }
  }, [loading, hasDivision02, navigate]);


  if (loading) return null;

  return (
    <>
      {hasDivision02 && <Breadcrumbs/>}

      <PageTitle>Access Restricted</PageTitle>

      <p>This dealer is not allowed to access Land Pride Dealer Access.</p>
      {associatedDealers.length > 0 &&
        <p> Please switch to a valid Land Pride dealer or go to Great Plains
          Dealer Access.</p>}

      {associatedDealers.length > 0 &&
        <button className={'text-only bold primary'} onClick={switchDealer}>
          <Icon glyph={'arrow-repeat'}/> Switch Dealer
        </button>
      }
      <br/>

      <a
        href={otherDivisionUrl}
        rel="noopener noreferrer"
      >
        <Icon glyph={'chevron-left'}/> Go to Great Plains Dealer Access
      </a>
    </>
  );
};

const WrongDivision = () => {
  const logger = useLogger();
  return (
    <ErrorBoundary logger={logger}>

      <WrongDivisionContent/>

    </ErrorBoundary>
  );
};

export default WrongDivision;
